import React, { useEffect } from 'react';
import { _ } from '_locales';
import styled from 'styled-components';
import parse from 'html-react-parser';
import { colors } from '_styles';
import { eventTracker } from '_helpers';
import { useParams } from 'react-router-dom';
import events from '../../Education/events';

const NewsDetailsContainer = styled.div`
  margin-bottom: 45px;
  box-sizing: border-box;
  padding: 0 19px;
`;

const NewsBox = styled.div`
  padding: 0 20px;
  max-width: 530px;
  box-sizing: border-box;
  margin: 0 auto;
`;

const NewsDate = styled.h3`
  padding-bottom: 20px;
  font-size: 14px !important;
   
  color: #656565;
  font-weight: 500 !important;
`;

const NewsContent = styled.div`
  padding-bottom: 20px;
  font-size: 16px !important;
   
  font-weight: normal !important;
  line-height: 1.7em;
  margin-bottom: 15px !important;
  margin-top: 15px !important;
  font-weight: 500 !important;

  p {
    line-height: 1.7em;
    color: #666;
  }

  title {
    display: block !important;
    font-size: 18px !important;
     
    -webkit-align-self: center;
    -ms-flex-item-align: center;
    -ms-grid-row-align: center;
    align-self: center;
    font-weight: 200 !important;
    margin-bottom: 10px;
  }

  b {
    font-weight: bold !important;
  }

  a {
    color: ${colors.RC_ACTION} !important;

    &:hover {
      color: ${colors.RC_ACTION} !important;
    }
  }
`;

const NewsType = styled.h4`
  padding-bottom: 8px;
  font-size: 13px !important;
   
  border-top: 1px solid #ddd;
  padding-top: 12px;
`;

const NewsTypeMessage = styled.span`
  font-weight: bold !important;
`;

const NewsDetails = ({ props }) => {
  const { topicId } = useParams();
  const { location } = props;
  const { content, type, date } = location.state;

  useEffect(() => {
    eventTracker(events.NEWS_LIST_LOAD, { com_id: topicId });
  }, []);

  return (
    <NewsDetailsContainer>
      <NewsBox>
        <NewsDate>{date}</NewsDate>
        <NewsContent>{parse(content)}</NewsContent>
        <NewsType>
          <NewsTypeMessage>
            {_('news.message_type')}
            {' '}
          </NewsTypeMessage>
          {type}
        </NewsType>
      </NewsBox>
    </NewsDetailsContainer>
  );
};

export default NewsDetails;
